import { BehaviorSubject } from 'rxjs';
export const fullScreenToggleAction$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
